import { render, staticRenderFns } from "./VFileInputMultipleDefault.vue?vue&type=template&id=66aed0e2&scoped=true&"
import script from "./VFileInputMultipleDefault.vue?vue&type=script&lang=js&"
export * from "./VFileInputMultipleDefault.vue?vue&type=script&lang=js&"
import style0 from "./VFileInputMultipleDefault.vue?vue&type=style&index=0&id=66aed0e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aed0e2",
  null
  
)

export default component.exports